import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';

import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';
import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25.js';

import 'commons-vehicle/Vehicle/components/CallToAction/PriceQuote/PriceQuoteCTA.scss';

const PriceQuoteCTAV25 = ({ vehicle, buttonClass, alternativeLabel, iconClass, onClick }) => {
    const locale = LocaleService.getSimpleLocale();
    let priceQuoteUrl;
    if (vehicle?.getIsVehicleNew()) {
        priceQuoteUrl = vehicle?.isSold()
            ? REDIRECTIONS[locale].soldPriceQuoteFormNew
            : REDIRECTIONS[locale].priceQuoteFormNew;
    } else {
        priceQuoteUrl = vehicle?.isSold()
            ? REDIRECTIONS[locale].soldPriceQuoteFormUsed
            : REDIRECTIONS[locale].priceQuoteFormUsed;
    }
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{make}', vehicle?.make?.name);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{model}', vehicle?.model?.name);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{year}', vehicle?.year);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{trim}', vehicle?.modelTrim?.name);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{stock}', vehicle?.stockNumber);
    priceQuoteUrl = UrlService.replaceParamWithValue(priceQuoteUrl, '{id}', vehicle?.vehicleId);
    priceQuoteUrl = UrlService.replaceParamWithValue(
        priceQuoteUrl,
        '{trimId}',
        vehicle?.configuration?.smNewTrimCarId || vehicle?.newCarTrimId
    );
    priceQuoteUrl = priceQuoteUrl.replace(/\s/g, '-');

    const currentClass = [buttonClass, 'vehicle-cta-btn'];
    return (
        <a href={priceQuoteUrl} className={currentClass.join(' ')} onClick={onClick}>
            {iconClass && <icon className={iconClass} />}
            <span>{alternativeLabel || LocaleService.t('CALL_TO_ACTION.BTN_PRICE_QUOTE_TEXT')}</span>
        </a>
    );
};

PriceQuoteCTAV25.defaultProps = {
    buttonClass: 'sr-button-1',
    alternativeLabel: null,
    iconClass: null,
    onClick: noop,
};

PriceQuoteCTAV25.propTypes = {
    vehicle: PropTypes.instanceOf(VehicleModelV25).isRequired,
    buttonClass: PropTypes.string,
    alternativeLabel: PropTypes.string,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
};

PriceQuoteCTAV25.displayName = 'PriceQuoteCTAV25';

export default PriceQuoteCTAV25;
